mutation updateCompanyAmbassadorSignatureCustomTemplateSignature(
  $input: UpdateCompanyAmbassadorSignatureCustomTemplateSignatureInput!
) {
  updateCompanyAmbassadorSignatureCustomTemplateSignature(input: $input)
}
